const strings = Object.freeze({
  SITE_NAME: 'DevGrid',
  DEFAULT_PAGE_TITLE: 'DevGrid',
  LEGAL_NAME: 'DevGrid, Inc.',
});

export default strings;
